<template>
  <b-container id="footer-container" fluid>
    <b-row class="justify-content-center">
      <b-col md="10">
        <b-row align-h="start" align-v="end" class="title-container">
          <b-col cols="7" md="4">
            <a href="/">
              <img alt="gravity logo" src="../assets/gravity-logo.png" />
            </a>
          </b-col>
          <b-col cols="5" md="8">
            <div class="color-design"></div>
          </b-col>
        </b-row>


        <b-row class="links-container">

          <b-col cols="6" md="2">
            <div class="title-container">
              <p class="link-title">COMMUNITY</p>
              <div class="color-line"></div>
            </div>
            <b-row
              class="link-list"
              v-for="link in communityLinks"
              v-bind:key="link.id"
            >
              <b-col>
                <a :href="link.url" class="link">{{ link.label }}</a>
              </b-col>
            </b-row>
          </b-col>

          <!--
          <b-col cols="6" md="3">
            <div class="title-container">
              <p class="link-title">ABOUT</p>
              <div class="color-line"></div>
            </div>
            <b-row class="link-list" v-for="link in aboutLinks" v-bind:key="link.id">
              <b-col>
                <p @click="openLink(link.url)" class="link">{{link.label}}</p>
              </b-col>
            </b-row>
          </b-col>
          -->


          <b-col cols="6" md="3">
            <div class="title-container">
              <p class="link-title">SHOWS</p>
              <div class="color-line"></div>
            </div>
            <b-row class="link-list" v-for="link in aboutLinks" v-bind:key="link.id">
              <b-col>
                <a :href="link.url" class="link">{{ link.label }}</a>
              </b-col>
            </b-row>
          </b-col>


          <b-col cols="6" md="3" class="products-links-container">
            <div class="title-container">
              <p class="link-title">PRODUCTS</p>
              <div class="color-line"></div>
            </div>
            <b-row>
              <b-col cols="6">
                <b-row
                  class="link-list"
                  v-for="link in productsFirstColumLinks"
                  v-bind:key="link.id"
                >
                  <b-col>
                    <a :href="link.url" class="link">{{ link.label }}</a>
                  </b-col>

                </b-row>
              </b-col>
              <!--
              <span v-if="0">
                <b-col cols="6" >
                  <b-row
                    class="link-list"
                    v-for="link in productsSecondColumLinks"
                    v-bind:key="link.id"
                  >
                    <b-col>
                      <p @click="openLink(link.url, link.id)" class="link">
                        {{ link.label }}
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
              </span>
              -->
            </b-row>
          </b-col>


          <b-col cols="6" md="2" class="products-links-container">
            <div class="title-container">
              <p class="link-title">COMPANY</p>
              <div class="color-line"></div>
            </div>
            <b-row
              class="link-list"
              v-for="link in legalLinks"
              v-bind:key="link.id"
            >
              <b-col>
                <a :href="link.url" class="link">{{ link.label }}</a>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6" md="2" class="products-links-container">
            <div class="title-container">
              <p class="link-title">Lists</p>
              <div class="color-line"></div>
            </div>
            <b-row
              class="link-list"
              v-for="link in companyLinks"
              v-bind:key="link.id"
            >
              <b-col>
                <a :href="link.url" class="link">{{ link.label }}</a>
              </b-col>
            </b-row>
          </b-col>


        </b-row>


        <b-row align-v="center">
          <b-col class="copyright-container">
            <p class="copyright-label">Copyright Gravity 2020 <br> <a href="https://www.launchgravity.com/terms-of-use" style="color:darkslategray">Terms</a><a href="https://www.launchgravity.com/privacy" style="color:darkslategray"> Privacy</a></p>
            <!-- </b-col>
            <b-col cols="3">-->
            <a href="/">
              <img alt="av logo" src="../assets/av-logo.png" />
            </a>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="9"></b-col>
    </b-row>
    <b-row class="background-container"></b-row>
  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/_components/footer.sass
</style>

<script>
export default {
  name: 'Footer',
  data: function() {
    return {
      communityLinks: [
        {
          id: 2, label: 'Slack', url: 'https://join.slack.com/t/launchgravity/shared_invite/zt-h2544c4g-AC6KOBYRVBtcT_m70NG1jg'
        },
        {
          id: 1,
          label: 'Facebook',
          url: 'https://www.facebook.com/groups/crushyourquota/',
        },

/*        {
          id: 12,
          label: 'YouTube Channel',
          url:
            'https://www.youtube.com/channel/UCmBU4QACrBqAAOTItIRX9nA/videos?view_as=subscriber',
        },
        {
          id: 12,
          label: 'Meetup Group',
          url: 'https://www.meetup.com/MastersofMarketingSF/',
        },*/
      ],

      aboutLinks: [
        {
          id: 0,
          label: 'Crush Your Quota',
          url: 'https://www.launchgravity.com/shows/crush-your-quota',
        },
        {
          id: 1,
          label: 'Masters of Marketing',
          url: 'https://www.launchgravity.com/masters-of-marketing',
        },

        // { id: 2, label: 'Contact Us', url: '/contact-us' },
      ],
      legalLinks: [
        { id: 0, label: 'About Us', url: 'https://www.launchgravity.com/about-us' },
        { id: 0, label: 'Careers', url: 'https://angel.co/company/launchgravity/jobs' },
        // { id: 3, label: 'Privacy Privacy', url: 'https://www.launchgravity.com/privacy' },
        // { id: 4, label: 'Terms of Use', url: 'https://www.launchgravity.com/terms-of-use' },
        //{ id: 5, label: 'Message Policy', url: 'https://www.launchgravity.com/messaging-policy' },
        //{ id: 6, label: 'Report Abuse', url: 'https://www.launchgravity.com/report-abuse' },
      ],
      productsFirstColumLinks: [
        { id: 10, label: 'Rocket Signals', url: 'https://getrocketsignals.com/',},
        { id: 10, label: 'Little Black Book', url: 'https://getlittleblackbook.com/',},
      ],
      productsSecondColumLinks: [
        { id: 1, label: 'Rocket Leads', url: 'url_rocket_leads' },
        { id: 2, label: 'Video-Cast', url: 'url_video_cast' },
        { id: 3, label: 'Gravity CRM', url: 'url_gravity_crm' },
        { id: 4, label: 'Rocket Signals', url: 'url_rocket_signals' },
      ],
      companyLinks:[
        { id: 1, label: 'Fastest Growing Company Directory', url: '/recipes/track-fast-growing-companies' },
        { id: 2, label: 'Funding Signal Data Drop', url: 'https://getrocketsignals.com/data-drop-list' },
      ],
    }
  },
  methods: {
    openLink(url, id) {
      if (id > 9){
        window.open(url,"_blank")
      } else {
        window.open(url,"_self")
      }
      console.log('open link', url)

    },
  },
}
</script>
